import { AssistantLaunchRecord } from '../../../shared/models/revenue/AssistantLaunchReport';

const normalizeOrganizationName = (value?: string) => (value || '')
    .trim()
    .toLowerCase()
    .replace(/['’]/g, '')
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();

const excludedDashboardOrganizations = new Set<string>([
    'dont use oops org'
].map(normalizeOrganizationName));

export const isDashboardOrganization = (record: AssistantLaunchRecord) => {
    const organizationName = record.organizationName || record.organization || record.orgName;
    return !excludedDashboardOrganizations.has(normalizeOrganizationName(organizationName));
};

export const uniqueLiveLocations = (records: AssistantLaunchRecord[]) => {
    const locations = new Map<string, AssistantLaunchRecord>();
    const primaryLocationKeyByName = new Map<string, string>();
    const manageMenuKeyByName = new Map<string, string>();
    records.forEach((record, index) => {
        const organization = (record.organizationId || record.organizationName || record.organization || record.orgName || 'unassigned').trim().toLowerCase();
        const applicationName = (record.applicationName || record.name || '').trim();
        const isManageMenu = /\(manage menu\)\s*$/i.test(applicationName);
        const normalizedName = applicationName
            .replace(/\s*\(manage menu\)\s*$/i, '')
            .trim()
            .replace(/\s+/g, ' ')
            .toLowerCase();
        const nameKey = normalizedName ? `${organization}|${normalizedName}` : '';

        if (isManageMenu && nameKey) {
            // A real location with the same base name already represents this helper app.
            if (primaryLocationKeyByName.has(nameKey)) return;
            const key = record.applicationId || record.id || `${nameKey}|manage-menu-${index}`;
            locations.set(key, record);
            manageMenuKeyByName.set(nameKey, key);
            return;
        }

        // If the helper arrived first, replace it with the real location application.
        if (nameKey && manageMenuKeyByName.has(nameKey)) {
            locations.delete(manageMenuKeyByName.get(nameKey)!);
            manageMenuKeyByName.delete(nameKey);
        }

        // Application identity is authoritative. Two real apps may legitimately share a name.
        const key = record.applicationId || record.id || `${nameKey || organization}|record-${index}`;
        locations.set(key, record);
        if (nameKey && !primaryLocationKeyByName.has(nameKey)) primaryLocationKeyByName.set(nameKey, key);
    });
    return Array.from(locations.values());
};
